<template>
  <main class="page-content mb-auto w-100 text-center" aria-label="Content">
    <!-- First Container -->
    <div class="section-wrap">
      <div class="section-content">
        <section class="section">
          <div class="header">
            <h1>Sieh dir jetzt deine Unterstützung an</h1>
          </div>
          <div class="content">
            <div class="content-center-group">
              <div class="search-container mt-5">
                <div class="input-group mt-3">
                  <input
                    class="form-control form-control-input-search"
                    type="text"
                    placeholder="Suche nach einem Laden"
                    v-model="query"
                    v-on:keyup.enter="debounceSearch"
                  />
                  <div class="ml-2">
                    <button
                      :disabled="loading"
                      type="button"
                      class="btn btn-primary"
                      v-on:click="debounceSearch"
                    >Suchen</button>
                  </div>
                </div>
                <div class="mt-2">
                  <router-link class="create-company-link" to="create">Nicht gefunden? Melde es hier</router-link>
                </div>
                <div class="mt-5 company-search-panel">
                  <div v-if="!loading">
                    <div
                      class="btn atom search-selection"
                      v-on:click="handleSelectCompany(company)"
                      v-for="company in companies"
                      :key="company.companyOriginReference"
                    >
                      <h5 class="text-primary">{{company.name}}</h5>
                      <h6
                        class="font-weight-normal"
                      >{{company.addresses[0].street}} {{company.addresses[0].houseNumber}}, {{company.addresses[0].zipCode}} {{company.addresses[0].town}}</h6>
                    </div>
                  </div>
                  <div v-if="companiesStoredMatched && !loading" class="mt-3">
                    <div
                      class="btn atom search-selection"
                      v-on:click="goToCompany(company.uid)"
                      v-for="company in companiesStoredMatched"
                      :key="company.uid"
                    >
                      <h5 class="text-primary">{{company.name}}</h5>
                      <h6 class="font-weight-normal">{{company.address}}</h6>
                    </div>
                  </div>
                  <div
                    v-if="searchError && !companiesStoredMatched.length"
                    class="company-search-empty-message"
                  >Leider haben wir nichts gefunden. Versuche den Suchtext anzupassen.</div>
                  <vueContentLoading :width="300" :height="100" v-if="loading">
                    <rect x="0" y="0" rx="4" ry="4" width="100%" height="20" />
                    <rect x="0" y="25" rx="4" ry="4" width="100%" height="20" />
                    <rect x="0" y="50" rx="4" ry="4" width="100%" height="20" />
                    <rect x="0" y="75" rx="4" ry="4" width="100%" height="20" />
                  </vueContentLoading>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Second Container -->
    <total-donation-report></total-donation-report>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/app";
import elasticlunr from "elasticlunr";
import { searchCompanies } from "../../services/KlaraCovidaContainer";
import TotalDonationReport from "@/components/TotalDonationReport.vue";
import VueContentLoading from "vue-content-loading";

let db = firebase.firestore();
let companiesRef = db.collection("companies");

var indexElasticlunr = elasticlunr(function() {
  this.addField("address");
  this.addField("emailAddress");
  this.addField("name");
  this.addField("phoneNumber");
  this.setRef("uid");
});

export default {
  name: "Companies",
  components: {
    totalDonationReport: TotalDonationReport,
    vueContentLoading: VueContentLoading
  },
  data: function() {
    return {
      companiesStored: [],
      uidCompaniesStoredMatched: [],
      companies: [],
      query: "",
      loading: false,
      searchError: false
    };
  },
  computed: {
    ...mapGetters({
      loggedIn: "loggedIn"
    }),
    companiesStoredMatched: function() {
      let $this = this;
      return this.companiesStored.filter(function(company) {
        return $this.uidCompaniesStoredMatched.includes(company.uid);
      });
    }
  },
  mounted: function() {
    let $this = this;
    companiesRef
      .where("userCreated", "==", true)
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          let company = Object.assign({ uid: doc.id }, doc.data());
          $this.companiesStored.push(company);
          indexElasticlunr.addDoc(company);
        });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },
  methods: {
    debounceSearch: function() {
      this.searchError = false;
      this.query = this.query.trim();

      if (!this.query) {
        this.companies = [];
        this.uidCompaniesStoredMatched = [];
        return;
      }
      let $this = this;

      this.uidCompaniesStoredMatched = [];
      indexElasticlunr
        .search(this.query, {
          expand: true
        })
        .forEach(function(item) {
          $this.uidCompaniesStoredMatched.push(item.ref);
        });

      this.loading = true;
      this.companies = [];
      searchCompanies(this.query)
        .then(res => {
          if (res.data && res.data.length) {
            $this.companies = res.data.filter(function(company) {
              return company.uid;
            });
          } else {
            $this.searchError = true;
          }

          $this.loading = false;
        })
        .catch(() => {
          $this.loading = false;
          $this.searchError = true;
        });
    },

    handleSelectExistedCompany: function(companyId) {
      this.goToCompany(companyId);
    },

    goToCompany: function(companyId) {
      this.$router.push({
        path: `/companies/${companyId}/detail`,
        params: { companyId: companyId }
      });
    },

    handleSelectNewCompany: function(selectedCompany) {
      let $this = this;
      let newComanyData = {
        uid: selectedCompany.uid,
        name: selectedCompany.name,
        address:
          selectedCompany.addresses[0].street +
          " " +
          selectedCompany.addresses[0].houseNumber +
          ", " +
          selectedCompany.addresses[0].zipCode +
          " " +
          selectedCompany.addresses[0].town,
        phoneNumber: selectedCompany.phoneNumber,
        emailAddress: selectedCompany.emailAddress,
        userCreated: false
      };

      companiesRef
        .doc(newComanyData.uid)
        .set(newComanyData)
        .then(function() {
          $this.goToCompany(newComanyData.uid);
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
        });
    },

    handleSelectCompany: function(selectedCompany) {
      if (!selectedCompany.uid) {
        return;
      }

      if (selectedCompany.uid) {
        let $this = this;

        companiesRef
          .doc(selectedCompany.uid)
          .get()
          .then(function(storedCompany) {
            if (storedCompany.exists) {
              $this.handleSelectExistedCompany(storedCompany.data().uid);
            } else {
              $this.handleSelectNewCompany(selectedCompany);
            }
          })
          .catch(function(error) {
            console.log("Error getting company:", error);
          });
      }
    }
  }
};
</script>

<style>
</style>
